import { useState, useEffect } from "react";
import { useStateContext } from "../context/StateContext";
import { useOfflineContext } from "../context/OfflineContext";


/**
 * Hook that returns the current network status.
 *#offlineUpdate
 * Returns true if the user is online, false otherwise.
 *
 * @returns {boolean} The current network status.
 */
const useNetworkStatus = () => {
  const [status, setStatus] = useState(navigator?.onLine);
  const { manualOffline } = useStateContext();
  const {setBypassOffline, bypassOffline} = useOfflineContext()

  useEffect(() => {
    const updateStatus = () => {
      if (manualOffline) {
        setStatus(false);
      } else {
        // When not manually offline, fall back to browser's online status
        setStatus(navigator?.onLine);
      }
    };

    const handleOnline = () => {
      if (!manualOffline) setStatus(true);
    };

    const handleOffline = () => {
      //console.log("lmdksmdlk", {status, bypassOffline})
      if (!manualOffline) setStatus(false);
      setBypassOffline(false);
    };

    // Initial check
    updateStatus();

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [manualOffline]);

  return status;
};

export default useNetworkStatus;